import React, { useState, useEffect, useRef } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import { ClipLoader, PropagateLoader } from 'react-spinners';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { AsyncPaginate } from 'react-select-async-paginate';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import "../customerMaster/customerListing.css";
import "./reports.css";
import { useReportCards } from "../shared/reportCards";

const ReceiptLogNarration = () => {
    const apiService = new LeaseApiService();
    const gridRef = useRef();
    const ITEMS_PER_PAGE = 100
    const { currencyPrecision } = useCurrency();
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [exportData, setExportData] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [typeList, setTypeList] = useState([]);
    const [tanentList, setTanentList] = useState([]);
    const [unitClass, setUnitClass] = useState([]);
    const [paymentList, setpaymentList] = useState([]);
    const [formData, setFormData] = useState({
        unitClass: "",
        tanentId: "",
        tanentName: "",
        property: "",
        from: "",
        to: "",
        unitNo: "",
        receiptType: "",
        paymentMethod: "",
        collection: "",
    })

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    useEffect(() => {
        fetchDropdownData()
        const today = new Date();
        let todate = formatDate(today)
        setFormData((prev) => ({ ...prev, to: todate, from: todate }));
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties,LRNaSearchUnitClass,LRAgreeSearchCustomers,LRNaSearchReceiptType,LRNaSearchPaymentMethod');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties)
            setpaymentList(res?.data?.dropdowns?.LRNaSearchPaymentMethod)
            setTypeList(res?.data?.dropdowns?.LRNaSearchReceiptType)
            setTanentList(res?.data?.dropdowns?.LRAgreeSearchCustomers)
            setUnitClass(res?.data?.dropdowns?.LRNaSearchUnitClass)

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }

    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("LeaseReceiptLog.ReceiptType", formData?.receiptType?.label || "All");
            params.append("LeaseReceiptLog.PropertyNo", formData?.property?.label || "All");
            params.append("LeaseReceiptLog.UnitNo", formData?.unitNo?.label || "All");
            params.append("LeaseReceiptLog.CustomerId", formData?.tanentId?.label || formData?.tanentName?.value?.value || "All");
            params.append("LeaseReceiptLog.FromDate", formData?.from || todate);
            params.append("LeaseReceiptLog.ToDate", formData?.to || todate);
            params.append("LeaseReceiptLog.PaymentMethod", formData?.paymentMethod?.label || "All");
            params.append("LeaseReceiptLog.Collection", formData?.collection || false);
            params.append("LeaseReceiptLog.UnitClass", formData?.unitClass?.label || "All");
            const res = await apiService.getApiParamater("REPORT_LEASE_RECEIPT_NARRATION", `?${params.toString()}`);
            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            setLoader(false)
            console.error("Error fetching items:", error);
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("LeaseReceiptLog.ReceiptType", formData?.receiptType?.label || "All");
            params.append("LeaseReceiptLog.PropertyNo", formData?.property?.label || "All");
            params.append("LeaseReceiptLog.UnitNo", formData?.unitNo?.label || "All");
            params.append("LeaseReceiptLog.CustomerId", formData?.tanentId?.label || formData?.tanentName?.value?.value || "All");
            params.append("LeaseReceiptLog.FromDate", formData?.from || todate);
            params.append("LeaseReceiptLog.ToDate", formData?.to || todate);
            params.append("LeaseReceiptLog.PaymentMethod", formData?.paymentMethod?.label || "All");
            params.append("LeaseReceiptLog.Collection", formData?.collection || false);
            params.append("LeaseReceiptLog.UnitClass", formData?.unitClass?.label || "All");
            const res = await apiService.getApiParamater("REPORT_LEASE_RECEIPT_NARRATION", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                setExportData(result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            // Handle error (e.g., show error message to user)
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2)
            ? 0
            : momentDate1.isBefore(momentDate2)
                ? -1
                : 1;
    }
    const columnDefs = [
        { headerName: "Property", field: "propertyName", filter: true, floatingFilter: true, suppressMovable: true, width: 250, pinned: "left", },
        { headerName: "Unit No", field: "unitNo", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Credit Account Name", field: "creditAccountName", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Receipt No", field: "receiptNo", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Ref No", field: "refNo", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Lease Start", field: "leaseData", filter: true, floatingfilter: true, valueFormatter: dateFormatter, comparator: dateComparator, suppressMovable: true, width: 136, },
        { headerName: "Receipt Date", field: "receiptDate", filter: true, floatingfilter: true, valueFormatter: dateFormatter, comparator: dateComparator, suppressMovable: true, width: 136, },
        { headerName: "Posting Date", field: "postingDate", filter: true, floatingfilter: true, valueFormatter: dateFormatter, comparator: dateComparator, suppressMovable: true, width: 136, },
        { headerName: "Method", field: "paymentMethod", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Payment Ref No", field: "city", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Amount", field: "amount", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Debit Account Code", field: "debitAcCode", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Debit Account Name", field: "debitAcName", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Narration", field: "narration", filter: true, floatingFilter: true, suppressMovable: true, width: 200, },
        { headerName: "Created By", field: "createdBy", filter: true, floatingFilter: true, suppressMovable: true, width: 200, },
    ]
    const handleClearFilters = () => {
        setUnitList([])
        const today = new Date();
        let todate = formatDate(today)
        setFormData({
            unitClass: "",
            tanentId: "",
            tanentName: "",
            property: "",
            unitNo: "",
            receiptType: "",
            paymentMethod: "",
            collection: "",
            from: todate,
            to: todate,
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "property") {
            setFormData(prev => ({ ...prev, unitNo: null }));
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRAgreehUnitNosByPropertyId');
            params.append('CascadValue', value?.value?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setUnitList(res?.data?.items)
        }
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return ""; // keep this if you want 0 to be empty

        // Check if value is a date string in ISO format
        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
            return moment(value).format("DD-MMM-YYYY");
        }

        return value;
    };
    const exportPDF = () => {
        if (!exportData?.length) return;
        const doc = new jsPDF("landscape", "pt", "A4");
        const columns = [
            { header: "Property", dataKey: "propertyName", width: 120 },
            { header: "Unit No", dataKey: "unitNo", width: 60 },
            { header: "Credit Account", dataKey: "creditAccountName", width: 120 },
            { header: "Receipt No", dataKey: "receiptNo", width: 80 },
            { header: "Receipt Date", dataKey: "receiptDate", width: 70 },
            { header: "Posting Date", dataKey: "postingDate", width: 70 },
            { header: "Method", dataKey: "paymentMethod", width: 70 },
            { header: "Amount", dataKey: "amount", width: 70 },
            { header: "Debit A/C Code", dataKey: "debitAcCode", width: 80 },
            { header: "Debit A/C Name", dataKey: "debitAcName", width: 120 },
            { header: "Narration", dataKey: "narration", width: 120 },
            { header: "Created By", dataKey: "createdBy", width: 120 },
        ];

        /* ========= HEADER ========= */

        doc.setFillColor(110, 81, 153); // #6E5199
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Receipt Log Narration Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Generated unit: ${moment(formData?.to).format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 160,
            32
        );

        doc.setTextColor(0);

        /* ========= TABLE ========= */
        doc.autoTable({
            startY: 60,
            head: [columns.map(col => col.header)],
            body: exportData.map(row =>
                columns.map(col => normalizeValue(row[col.dataKey]))
            ),
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save("Receipt_Narration_Report.pdf");
    };
    const exportExcel = () => {
        if (!exportData?.length) return;

        const columns = [
            { header: "Property", dataKey: "propertyName", width: 120 },
            { header: "Unit No", dataKey: "unitNo", width: 60 },
            { header: "Credit Account", dataKey: "creditAccountName", width: 120 },
            { header: "Receipt No", dataKey: "receiptNo", width: 80 },
            { header: "Receipt Date", dataKey: "receiptDate", width: 70 },
            { header: "Posting Date", dataKey: "postingDate", width: 70 },
            { header: "Method", dataKey: "paymentMethod", width: 70 },
            { header: "Amount", dataKey: "amount", width: 70 },
            { header: "Debit A/C Code", dataKey: "debitAcCode", width: 80 },
            { header: "Debit A/C Name", dataKey: "debitAcName", width: 120 },
            { header: "Narration", dataKey: "narration", width: 120 },
            { header: "Created By", dataKey: "createdBy", width: 120 },
        ];

        const excelData = exportData.map(item => {
            const row = {};
            columns.forEach(col => {
                let value = item[col.dataKey];
                if (col.header === "Amount") {
                    value = normalizeValue(value);
                    value = parseFloat(value).toFixed(currencyPrecision?.decimalNumbers || 3);
                } else {
                    value = normalizeValue(value);
                }
                row[col.header] = value;
            });
            return row;
        });

        // Create worksheet from data
        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // Calculate max width for each column
        const colWidths = columns.map(col => {
            const headerLength = col.header.length;
            const maxDataLength = Math.max(
                ...excelData.map(row => (row[col.header] ? row[col.header].toString().length : 0))
            );
            return { wch: Math.max(headerLength, maxDataLength) + 2 }; // add padding
        });

        // Assign the widths to the worksheet
        worksheet['!cols'] = colWidths;

        // Create and save workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Receipt log Narration Report");
        XLSX.writeFile(workbook, "Receipt_Narration_Report.xlsx");
    };

    const loadOptions = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.value })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const loadOptionsName = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.text })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const cards = useReportCards({
        label: "Receipts in view",
        rowData,
        exportData: exportData,
        pagination,
        fields: [["paymentMethod",2],["propertyName",2]],
    });

    return (
        <div className="cl-page rpt-legacy">
            <div className="cl-titlebar">
                <div className="cl-title">
                    <h1>Receipt Log with Narration</h1>
                    <p>Every receipt with its narration.</p>
                </div>
            </div>
            {cards.strip}
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Tenant ID</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={formData?.tenantId}
                                    loadOptions={loadOptions}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tenantId", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Tenant</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={formData?.tenantName}
                                    loadOptions={loadOptionsName}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tenantName", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit No</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label">From</label>
                                <DatePicker
                                    selected={formData.from}
                                    onChange={(date) => handleDateChange({ name: 'from', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label w-0">To</label>
                                <DatePicker
                                    selected={formData.to}
                                    onChange={(date) => handleDateChange({ name: 'to', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit Class</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitClass}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitClass', value: selectedOption })}
                                    options={unitClass?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Receipt Type</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.receiptType}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'receiptType', value: selectedOption })}
                                    options={typeList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Payment Method</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.paymentMethod}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'paymentMethod', value: selectedOption })}
                                    options={paymentList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div></div>
                            <div className="d-flex center gap-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="collection"
                                    style={{ width: '20px', height: '20px' }}
                                    checked={formData.followtoCheck}
                                    onChange={(e) => setFormData(prev => ({ ...prev, collection: e.target.checked }))}
                                />
                                <label className="form-check-label">Collection</label>
                            </div>

                            <div className="d-flex gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div
                                        onClick={() => getItems()}
                                        className="mainbtnGry flex-end gap-2 w-50"
                                    >
                                        <FaFileCircleExclamation
                                            color="#fff"
                                            className="center mt-2 mx-2"
                                        />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div
                                    onClick={() => handleClearFilters()}
                                    className="mainbtnRed flex-end gap-2 w-50"
                                >
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-contant-between ">
                            <h5 className="col mainInvHead">Receipt Log with Narration</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                Export as PDF
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                Export as Excel
                            </button>
                        </div>

                        <div className="gridshad mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    ref={gridRef}
                                    rowData={cards.shownRows}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            {!cards.active && <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />}
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default ReceiptLogNarration;
